module.exports = __webpack_public_path__ + "img/Nab-Logo.163114e0.png";